import type { FC, ReactElement } from "react"

import type { Governor, Proposal } from "query/graphql"
import { useDescriptionException } from "proposal/hooks/useDescriptionException"

type ProposalDescriptionExceptionWrapperProps = {
  children: (title: string) => ReactElement
  governance: Pick<Governor, "id">
  proposal: Proposal
}

const ProposalDescriptionExceptionWrapper: FC<
  ProposalDescriptionExceptionWrapperProps
> = ({ children, governance, proposal }) => {
  const { title } = useDescriptionException({
    proposal,
    governanceId: governance.id,
  })

  return children(title)
}

export default ProposalDescriptionExceptionWrapper
